
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import { ORDER_MENU_ITEM, ADVANCED_SEARCH_ORDER_SETTINGS } from "@/consts";
import DispatchOrdersTable from "@/components/order/DispatchOrdersTable.vue";
import OrderActions from "@/components/order/OrderActions.vue";
import notifications from "../lib/notifications";
import { DISPATCH_SHORTCUT } from "@/consts";

const orderModule = getModule(OrderModule);

@Component({
  components: {
    DispatchOrdersTable,
    OrderActions
  }
})
export default class AdvancedSearchResults extends Vue {
  ORDER_MENU_ITEM: any = ORDER_MENU_ITEM;
  searchOrderSettings: any = ADVANCED_SEARCH_ORDER_SETTINGS;
  shortcuts: any = DISPATCH_SHORTCUT;

  get menuItemsToDisplay() {

    return this.ORDER_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get renderAdvancedSearchResults() {
    return orderModule.renderAdvancedSearchResults;
  }

  get exportAdvancedSearchOrders() {
    return orderModule.exportAdvancedSearchOrders;
  }

  @Watch("renderAdvancedSearchResults")
  valChanged(newValue) {
    this.loadResults();
  }

  onFilter() {}

  async loadResults() {
    try {
      await orderModule.reloadAdvancedSearchResults({ page: 1 });
    } catch (ex) {
      notifications.error("Search Results", "Failed to load search results", ex);
    }
  }

  async onSort(s) {
    try {
      orderModule.applyAdvancedSearchSort(s);
    } catch (ex) {
      notifications.error("Search Results", "Failed to load search results", ex);
    }
  }

  async loadMoreOrders() {
    try {
      await orderModule.loadAdvancedSearch({});
    } catch (ex) {
      notifications.error("Order List", "Failed to load additional orders", ex);
    }
  }
}
